import { createPopper } from '@popperjs/core/lib/popper-lite'
import flip from '@popperjs/core/lib/modifiers/flip';

window.sfDocumentReady(['route-suppliers'], () => {
  window.setupDatatable('.js-datatable', 'asc', 0);

  $('.js-delete').on('click', async function (e) {
    e.preventDefault();

    try {
      if (confirm('Are you sure you want to delete this supplier?')) {
        $(this).attr('disabled', true);
        $('.js-loading').show();
        await Api.delete($(this).attr('href'));

        notifyBox('Deleted', 'Supplier deleted', 'success');
        setTimeout(() => location.reload(), 500);
      }
    } catch (err) {
      const status = _.get(err, 'response.status');
      const message = _.get(err, 'response.data.message', err.message);

      if (!ajaxErrorHandler(status)) {
        notifyBox(`Error (${status})`, message, 'error');
      }
    } finally {
      $(this).attr('disabled', false);
      $('.js-loading').hide();
    }
  });

  $('[data-tooltip]').each((_, el) => {
    const placement = $(el).data('tooltip') || 'top'
    const title = $(el).attr('title').replace(/((https?:)?\/\/[^\s]+)/, '<textarea class="text-center referral-link" disabled="disabled">$1</textarea>');
    const tooltipEl = el._tooltipEl || $('<div/>', { class: `tooltip tooltip--balloon tooltip--${placement}` }).html(title).get(0)

    el.appendChild(tooltipEl)

    createPopper(el, tooltipEl, {
      placement: placement,
      modifiers: [flip]
    });

    $(el).on('click', function (e) {
      e.preventDefault();

      const targetInput = $(this).find('.referral-link');

      if (targetInput.length) {
        try {
          targetInput.attr('disabled', false);
          targetInput.trigger('focus');
          targetInput.trigger('select');
          document.execCommand('copy');
          targetInput.attr('disabled', true);

          const btnContent = $(this).html();
          $(this).html('Copied').attr('disabled', true);
          setTimeout(() => {
            $(this).html(btnContent).attr('disabled', false);
          }, 2000);
        } catch (err) {
          $(this).html('Copy failed, please do it manually').attr('disabled', true);
        }
      }
    });
  });
});

window.sfDocumentReady(['route-suppliers-create', 'route-suppliers-edit'], () => {
  $('.js-supplier-form').on('submit', async function (e) {
    e.preventDefault();

    try {
      $('.js-loading').show();
      $('.js-display-errors').html('');
      $(this).find('.btn--save').attr('disabled', true);
      const data = $(this).serialize();
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded"
      };

      let response
      if ($(this).find('[name="id"]').val()) {
        response = await Api.put($(this).attr('action'), data, { headers });
      } else {
        response = await Api.post($(this).attr('action'), data, { headers });
      }

      notifyBox('Saved', 'Supplier saved', 'success');

      // Create only
      // Done saving a new supplier will redirect to its detail page
      const url = _.get(response, 'data.url')
      if ($('body').hasClass('route-suppliers-create') && url) {
        setTimeout(() => location.href = url, 500);
      }
    } catch (err) {
      const status = _.get(err, 'response.status');
      const message = _.get(err, 'response.data.message', err.message);

      if (status === 422) {
        const errors = _.get(err, 'response.data.errors', []);

        _.each(errors, (fieldErrors, fieldName) => {
          $(`#${fieldName}-err`).html(_.get(fieldErrors, 0, ''))
        });
      } else if (!ajaxErrorHandler(status)) {
        notifyBox(`Error (${status})`, message, 'error');
      }
    } finally {
      $(this).find('.btn--save').attr('disabled', false);
      $('.js-loading').hide();
    }
  });

  $('.js-broker-dropdown').select2({
    width: '100%',
    matcher: createSelect2CharactersMatcher()
  });
});
